import * as PropTypes from 'prop-types'
import crossBrowserResize from 'cross-browser-resize'
import debounce from 'lodash/debounce'

import { BREAKPOINTS } from '/javascripts/constants/breakpoints'
import { isServer } from '/javascripts/checks'

export const withViewport = () => (WrappedComponent) => {
  class WithViewport extends React.PureComponent {
    static displayName = `withViewport(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`

    state = {
      viewportHeight: isServer ? 0 : window.innerHeight,
      viewportWidth: isServer ? 0 : document.body.clientWidth /* better then window.innerWidth because clientWidth takes the scrollbar width into account */
    }

    unMounted = false

    handleResize = debounce(() => {
      if (this.unMounted) return

      this.setState({
        viewportHeight: window.innerHeight,
        viewportWidth: document.body.clientWidth /* better then window.innerWidth because clientWidth takes the scrollbar width into account */
      })
    }, 250)

    componentDidMount () {
      crossBrowserResize.addListener(this.handleResize)
    }

    componentWillUnmount () {
      this.unMounted = true
      crossBrowserResize.removeListener(this.handleResize)
    }

    render () {
      const {
        forwardedRef,
        ...restProps
      } = this.props

      const {
        viewportWidth
      } = this.state

      const viewportProps = {
        viewportIsDesktopOrBigger: viewportWidth >= BREAKPOINTS.DESKTOP,
        viewportIsLaptopOrBigger: viewportWidth >= BREAKPOINTS.LAPTOP,
        viewportIsLaptopOrSmaller: viewportWidth < BREAKPOINTS.DESKTOP,
        viewportIsTabletOrBigger: viewportWidth >= BREAKPOINTS.TABLET,
        viewportIsTabletOrSmaller: viewportWidth < BREAKPOINTS.LAPTOP,
        viewportIsMobile: viewportWidth < BREAKPOINTS.TABLET
      }

      return <WrappedComponent ref={forwardedRef} {...restProps} {...this.state} {...viewportProps} />
    }
  }

  WrappedComponent.propTypes = {
    ...WrappedComponent.propTypes,
    viewportHeight: PropTypes.number.isRequired,
    viewportIsDesktopOrBigger: PropTypes.bool.isRequired,
    viewportIsLaptopOrBigger: PropTypes.bool.isRequired,
    viewportIsTabletOrBigger: PropTypes.bool.isRequired,
    viewportIsTabletOrSmaller: PropTypes.bool.isRequired,
    viewportIsMobile: PropTypes.bool.isRequired,
    viewportWidth: PropTypes.number.isRequired
  }

  return React.forwardRef((props, ref) => <WithViewport {...props} forwardedRef={ref} />)
}
